import { tileMapEditor } from '../editor/tileMapEditor-sidecar'
import { scene } from '../main/scene-sidecar'
import { worldSettings } from '../models/worldSettings-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { monsterSelector } from '../ui/monsterSelector-sidecar'
import { testRig_common } from './testRig_common-sidecar'

export const createTestRig_emO2 = (x: number, y: number) => {
  let ctx = scene.getContext()

  let w = 14
  let h = 7
  let std = tilesDataShip.getStandard()

  tileMapEditor.setMode('o2')

  worldSettings.setNeedsNull()
  // worldSettings.setNeeds({
  //   thirstRate: worldSettings.defaultNeeds.thirstRate * 10,
  // })

  testRig_common.createBasicShip(x, y)

  let m = monsters.create('human', 1)
  monsters.moveToTile(m, ctx.mapShip, x + 4, y + 3)
  m.isInsideShip = true
  monsters.setInSuit(m, false)
  monsterSelector.select(m)
}
